import Vue from 'vue';
import { getSwiper, getSwiperModules } from '../utils';

Vue.component('configurator-photo-slider-desktop', {
    props: {
        model: {
            value: String,
        },
        siteHandle: {
            value: String,
        },
    },

    data() {
        return {
            swiper: null,
            edition: '',
            color: '',
            exteriorOptions: '',
            interiorOptions: '',
            noLuxuryCountries: [
                'mgMotorsSweden',
                'mgMotorsIceland',
                'mgMotorsNorway',
            ],
            hasInteriorImage: false,
        };
    },

    mounted() {
        // Initiate slider.
        this.initSwiper();

        // Update color when it changes and switch to first slide.
        EventBus.$on('configurator-set-color', (color) => {
            this.color = color.colorSlug;
            if (!this.swiper) return;
            this.swiper.slideToLoop(0);
        });

        // Update edition when it changes.
        EventBus.$on('configurator-set-edition', (edition) => {
            this.edition = edition.field_commerceHandle;
            if (!this.swiper) return;

            if (this.$parent.hasInteriorImage != this.hasInteriorImage) {
                this.initSwiper();
                this.swiper.slideTo(0);
                return;
            }

            this.swiper.slideToLoop(0);
        });

        // Set proper classes when the edition options have changed.
        EventBus.$on('configurator-set-edition-options', (options) => {
            this.onEditionOptionsChange(options);
        });

        // Slide to proper slide when an edition option has been selected.
        EventBus.$on('configurator-set-edition-option', (option) => {
            this.onEditionOptionChange(option);
        });
    },

    watch: {
        edition(editionValue) {
            const isNoLuxuryCountries = this.noLuxuryCountries.includes(
                this.siteHandle,
            );
            const ehsSpainEditions = {
                luxury: 'luxury-spain',
                comfort: 'comfort-spain',
            };

            if (
                this.siteHandle === 'mgMotorsSpain' &&
                this.model === 'mg-ehs-2023' &&
                ehsSpainEditions[editionValue]
            ) {
                this.edition = ehsSpainEditions[editionValue];
                return;
            }

            if (!isNoLuxuryCountries || this.model !== 'mg4') return;
            if (editionValue === 'luxury') this.edition = 'comfort';
        },
    },

    methods: {
        async initSwiper() {
            const slider = this.$el.querySelector(
                '.configurator-slider__slider',
            );

            const { Swiper } = await getSwiper();
            const { Pagination, Navigation } = await getSwiperModules();

            this.swiper = new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                centeredSlides: true,
                allowTouchMove: false,
                modules: [Pagination, Navigation],
                uniqueNavElements: true,
                navigation: {
                    nextEl: '.slide-next',
                    prevEl: '.slide-prev',
                },
            });

            this.swiper.init();

            this.hasInteriorImage = this.$parent.hasInteriorImage;
        },

        /**
         * Set proper classes when the edition options have changed.
         *
         * @param {Array} options Array holding all the available options with this edition.
         * @returns {Void}
         */
        onEditionOptionsChange(options) {
            // Collect classes in arrays.
            let exteriorOptions = [];
            let interiorOptions = [];

            // Loop options to update arrays.
            for (let option in options) {
                // Add to the proper class array if this option is selected.
                if (options[option].selected) {
                    if (options[option].field_moveToSliderImage == 'interior') {
                        interiorOptions.push(
                            options[option].field_optionHandle,
                        );
                    }
                    if (options[option].field_moveToSliderImage == 'exterior') {
                        exteriorOptions.push(
                            options[option].field_optionHandle,
                        );
                    }
                }
            }

            // Update class properties.
            this.exteriorOptions = exteriorOptions.join(' ');
            this.interiorOptions = interiorOptions.join(' ');
        },

        /**
         * Slide to proper slide when an edition option has been selected.
         *
         * @param {Object} option The object of the option that has changed.
         * @returns {Void}
         */
        onEditionOptionChange(option) {
            if (!this.$parent.hasInteriorImage) {
                return;
            }

            // Slide to exterior slide if required by this option.
            if (option.field_moveToSliderImage == 'exterior') {
                this.swiper.slideToLoop(0);
            }

            // Slide to interior slide if required by this option.
            if (option.field_moveToSliderImage == 'interior') {
                this.swiper.slideToLoop(1);
            }
        },

        handleSantanderModalVisibility() {
            EventBus.$emit('handle-santander-modal-visibility');
        },

        handleSCFModalVisibility() {
            EventBus.$emit('handle-scf-modal-visibility');
        },
    },
});
